import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../components/Button';
import GuideForm from '../../components/Guide/GuideForm';
import BreadCrumb from '../../components/Breadcrumb';
import * as actions from '../../redux/actions/actions-guide';

class addGuide extends Component {
  constructor(props) {
    super(props);

    if (props.match.params.id !== '0') {
      props.setForm(props.match.params.id);
    } else {
      props.resetForm();
    }

    this.state = {};
  }


  handleSubmit = (FormData) => {
    this.props.saveGuide(FormData);
  }


  render() {
    return (
      <>
        <div className="container">
          <BreadCrumb currentPage="Guide" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-10">
                    { this.props.match.params.id !== '0'
                      ? <span className="fa fa-pencil-alt cardTitle"> Edit Guide</span>
                      : <span className="fa fa-plus-square cardTitle"> Create New Guide</span>}
                  </div>
                  <div className="col-md-2 text-right">
                    <Button
                      className="btn btn-sm btn-secondary"
                      onClick={() => this.props.history.goBack()}
                    >
                      <span className="fa fa-arrow-left" />
                      {' '}
                      Back
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">
                {/* <h3>fnkbfgjbfgb</h3> */}
                <GuideForm
                  onSubmit={this.handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

addGuide.propTypes = {
  formLoading: PropTypes.bool,
  formError: PropTypes.string,
  saveGuide: PropTypes.func
};

addGuide.defaultProps = {
  formLoading: null,
  formError: null,
  saveGuide: null
};

const mapStateToProps = ({ guide }) => ({});


const mapDispatchToProps = (dispatch) => ({
  saveGuide: (data) => dispatch(actions.saveGuide(data)),
  setForm: (id) => dispatch(actions.editGuide(id)),
  resetForm: () => dispatch(actions.resetForm())
});

export default connect(mapStateToProps, mapDispatchToProps)(addGuide);
